import states from "states-us";

export const STATE_OPTIONS = states
  .filter((state) => !state.territory)
  .map((state) => ({
    value: state.abbreviation,
    label: state.name
  }));
